import { useEffect, useState } from 'react';
import { convertToMaritime } from '../../location/helpers';
import { useEnabledFeatures } from './enabled-features/use-enabled-features';
import { FormatType } from '../components/maritime-formats-buttons-section';

export function useMaritimeFormat({
    latitude,
    longitude,
}: {
    latitude?: number;
    longitude?: number;
}) {
    const [maritimeFormat, setMaritimeFormat] = useState<FormatType>('DD');
    const [formattedValue, setFormattedValue] = useState<string>('');
    const { maritimeCoordinatesEnabled } = useEnabledFeatures();

    useEffect(() => {
        if (maritimeCoordinatesEnabled && latitude && longitude) {
            switch (maritimeFormat) {
                case 'DDM':
                case 'DMS': {
                    setFormattedValue(
                        `${convertToMaritime({
                            format: maritimeFormat,
                            coordinate: latitude,
                            isLatitude: true,
                        })}, ${convertToMaritime({
                            format: maritimeFormat,
                            coordinate: longitude,
                            isLatitude: false,
                        })}`
                    );

                    return;
                }
                case 'DD': {
                    setFormattedValue(`${latitude}, ${longitude}`);
                    return;
                }
            }
        }
    }, [maritimeFormat, latitude, longitude, maritimeCoordinatesEnabled, formattedValue]);

    return {
        maritimeFormat,
        setMaritimeFormat,
        formattedValue,
    };
}
